import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
    Heading,
    AspectRatio,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon, AddIcon, PlusSquareIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import { link } from 'fs';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611133&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - ERP',
};

const integrations = [
    {
        id: 0,
        title: 'Subiekt GT',
        link: 'https://www.idosell.com/pl/subiekt-gt-i-subiekt-nexo/',
        description:
            'Subiekt GT to intuicyjny system magazynowo-handlowy dla małych i średnich sklepów.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611701&ext=.png',
            alt: 'Logo Comarch ERP',
        },
    },
    {
        id: 1,
        title: 'Subiekt Nexo',
        link: 'https://www.idosell.com/pl/subiekt-gt-i-subiekt-nexo/',
        description:
            'Subiekt Nexo to nowoczesne oprogramowanie ERP, które łączy prostotę obsługi z zaawansowanymi funkcjami zarządzania sprzedażą i magazynem.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611702&ext=.png',
            alt: 'Logo Comarch ERP',
        },
    },
    {
        id: 2,
        title: 'Comarch ERP Optima',
        link: 'https://www.idosell.com/pl/comarch-erp-optima/',
        description:
            'Comarch ERP Optima to jedno z najczęściej wybieranych rozwiązań w Polsce, stworzone z myślą o małych i średnich sklepach z różnych branż.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611703&ext=.png',
            alt: 'Logo Symfonia ERP',
        },
    },
    {
        id: 3,
        title: 'WAPRO Mag',
        link: 'https://www.idosell.com/pl/wapro-mag/',
        description:
            'WAPRO Mag oferuje zaawansowane funkcje zarządzania sprzedażą, cennikami, rabatami oraz kontrolą zobowiązań i należności, wspierając zarówno sprzedaż offline, jak i online.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611704&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 4,
        title: 'Enova365',
        link: 'https://www.idosell.com/pl/enova365/',
        description:
            'Enova365 to nowoczesny system ERP, który został stworzony, żeby maksymalizować efektywność sklepów internetowych.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611705&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 5,
        title: 'Streamsoft Prestiż',
        link: 'https://www.idosell.com/pl/streamsoft/',
        description:
            'Streamsoft Prestiż ujednolica rozwiązania informatyczne w firmie i porządkuje procesy biznesowe, zapewniając spójność danych oraz pełną kontrolę nad procesami.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611706&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 6,
        title: 'Symfonia Handel',
        link: 'https://www.idosell.com/pl/idosell-bridge-integruje-subiekt-gt-subiekt-nexo-wapro-mag-dawniej-wf-mag-streamsoft-prestiz-comarch-erp-optima-enova365-kazdy-inny-erp/lista-obslugiwanych-programow-erp-/-f-k-/symfonia/',
        description:
            'Symfonia Handel to elastyczne oprogramowanie ERP, które wspiera sprzedaż, zarządzanie magazynem, dokumentami i płatnościami oraz ułatwia obsługę klientów.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611708&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 7,
        title: 'Inne systemy ERP',
        link: 'https://www.idosell.com/pl/developers/uniwersalny-tryb-pracy-udb-w-aplikacji-idosell-bridge-do-integracji-sklepu-internetowego-z-erp/',
        description:
            'Zintegruj dowolny system ERP ze swoim sklepem internetowym i automatycznie zarządzaj danymi o produktach, zamówieniach i stanach magazynowych.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611709&ext=.png',
            alt: 'Inne ERP',
        },
    },
];

export default function ERPPageComponent(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Integracja sklepu internetowego z systemami ERP"
                subTitle="Połącz sklep z systemem księgowo-magazynowym i zyskaj pełną kontrolę oraz automatyzację najważniejszych procesów, które pomagają zarządzać sprzedażą, księgowością i magazynem."
                image={heroImage}
                paddingDesktop="75px 0"
                gap="100px"
                buttons={[
                    {
                        title: 'Poznaj integracje',
                        href: '#integrations',
                        variant: 'default',
                        target: '_self',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', width: '370px' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611697&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611698&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box width={{ base: '100%', lg: '50%' }} flex={'1'} padding={'30px'}>
                                <Text
                                    fontSize={{ base: '25px', lg: '34px' }}
                                    fontWeight="semibold"
                                    className="text-wrapper-2"
                                    color="#1AAC7A"
                                    marginBottom={4}
                                >
                                    Co zyskasz dzięki integracjom z ERP?
                                </Text>
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 13.6929L11.0655 13.7004L8.94418 15.8217L3.68945 10.567L5.81077 8.44569L8.9367 11.5716L16.5083 4L18.6296 6.12132L11.058 13.6929Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Automatyczna synchronizacja stanów magazynowych i
                                                cen
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Unikaj problemów z nadmierną sprzedażą i brakami w
                                                magazynie dzięki bieżącej aktualizacji stanów
                                                produktów w sklepie.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 13.6929L11.0655 13.7004L8.94418 15.8217L3.68945 10.567L5.81077 8.44569L8.9367 11.5716L16.5083 4L18.6296 6.12132L11.058 13.6929Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Usprawnienie obsługi zamówień i fakturowania
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Przyspiesz proces realizacji zamówień i minimalizuj
                                                ręczną pracę.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 13.6929L11.0655 13.7004L8.94418 15.8217L3.68945 10.567L5.81077 8.44569L8.9367 11.5716L16.5083 4L18.6296 6.12132L11.058 13.6929Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Pełna kontrola nad finansami i raportowaniem
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Monitoruj przychody, koszty i zobowiązania w jednym
                                                miejscu, dzięki precyzyjnym raportom generowanym w
                                                czasie rzeczywistym.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 13.6929L11.0655 13.7004L8.94418 15.8217L3.68945 10.567L5.81077 8.44569L8.9367 11.5716L16.5083 4L18.6296 6.12132L11.058 13.6929Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Szybsza i bardziej efektywna obsługa klienta
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Błyskawiczny dostęp do historii zamówień, faktur i
                                                statusów płatności pozwala na sprawne odpowiadanie
                                                na pytania klientów.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 13.6929L11.0655 13.7004L8.94418 15.8217L3.68945 10.567L5.81077 8.44569L8.9367 11.5716L16.5083 4L18.6296 6.12132L11.058 13.6929Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Eliminacja błędów
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Automatyzacja procesów redukuje ryzyko pomyłek w
                                                zamówieniach czy stanach magazynowych, zwiększając
                                                niezawodność Twojego biznesu.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <CTASection
                    title="Wybierz najlepsze rozwiązanie dla swojej logistyki"
                    subtitle="W IdoSell masz pełną swobodę zarządzania magazynem – możesz skorzystać z naszego zaawansowanego systemu WMS, który zapewnia pełną kontrolę nad stanami i procesami magazynowymi lub zintegrować sklep z zewnętrznym systemem ERP, dostosowując rozwiązanie do swoich potrzeb."
                    buttons={[
                        {
                            title: 'System WMS w IdoSell',
                            href: 'https://www.idosell.com/pl/system-zarzadzania-magazynem/',
                            variant: 'default',
                        },
                    ]}
                />
                <Box
                    position={'relative'}
                    id="integrations"
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: '0px',
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: 'rgba(238, 238, 238, 1)',
                        },
                    }}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        gap={'10px'}
                        textAlign={'center'}
                        alignItems={'center'}
                    >
                        <Text fontSize={'34px'} lineHeight={'48px'} fontWeight={'600'}>
                            Integracje z systemami ERP w IdoSell
                        </Text>
                        <Text fontSize={'18px'} lineHeight={'27px'} fontWeight={'400'}>
                            Sprawdź wbudowane integracje z najważniejszymi systemami ERP i
                            automatyzuj najważniejsze i najbardziej czasochłonne procesy w swoim
                            sklepie internetowym.
                        </Text>
                    </Box>
                    <Box>
                        <Box
                            display={'grid'}
                            gridTemplateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }}
                            padding={{ base: '35px 0px 35px', md: '50px 15px' }}
                            gap={{ base: '20px', md: '30px' }}
                        >
                            {integrations.map(integration => (
                                <Box
                                    backgroundColor={'#fff'}
                                    padding={{ base: '16px', md: '25px' }}
                                    _hover={{
                                        boxShadow: '0px 12px 25px 0px #00000033',
                                        cursor: 'pointer',
                                    }}
                                    key={integration.id}
                                    role="group"
                                >
                                    <Link href={integration?.link}>
                                        <Box marginBottom={'16px'}>
                                            <Box
                                                padding={'8px'}
                                                boxShadow={'0px 4px 4px 0px #00000026'}
                                                width={'80px'}
                                                height={'80px'}
                                                _groupHover={{ transform: 'translateY(-10px)' }}
                                                transition="transform 0.2s ease-in-out"
                                            >
                                                <Image
                                                    src={integration?.image?.url}
                                                    alt={integration?.image?.alt}
                                                />
                                            </Box>
                                        </Box>
                                    </Link>
                                    <Box
                                        display={'flex'}
                                        flexDirection={'column'}
                                        justifyContent={'space-between'}
                                    >
                                        <Box
                                            marginBottom={{ base: '30px', md: '0' }}
                                            height={{ base: '143px', md: '183px' }}
                                        >
                                            <Text
                                                fontSize={{ base: '14px', md: '21px' }}
                                                fontWeight={'600'}
                                                lineHeight={'1.4'}
                                                marginBottom={'10px'}
                                            >
                                                {integration.title}
                                            </Text>
                                            <Text
                                                fontSize={'12px'}
                                                fontWeight={'400'}
                                                lineHeight={'19px'}
                                            >
                                                {integration.description}
                                            </Text>
                                        </Box>
                                        <Box
                                            display={'flex'}
                                            alignItems={'center'}
                                            gap={'10px'}
                                            justifyContent={'space-between'}
                                        >
                                            <Box
                                                display={'flex'}
                                                flexDirection={{ base: 'column', md: 'row' }}
                                                alignItems={'center'}
                                                gap={{ base: '0', md: '10px' }}
                                            >
                                                <Link
                                                    color={'#171717'}
                                                    href={integration?.link}
                                                    fontSize={{ base: '12px', md: '13px' }}
                                                    lineHeight={{ base: '1.5', md: '1.5' }}
                                                    textDecor={'underline'}
                                                    _hover={{
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    Dowiedz się więcej
                                                </Link>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        {integrations.length > 8 && (
                            <Button
                                // onClick={toggleShowAll}
                                fontSize={'16px'}
                                fontWeight={'600'}
                                lineHeight={'21px'}
                                textAlign={'center'}
                                textDecoration={'underline'}
                                background={'none'}
                                width={'100%'}
                                _hover={{
                                    background: 'none',
                                    textDecoration: 'none',
                                }}
                                marginTop={'0'}
                            >
                                Pokaż
                            </Button>
                        )}
                    </Box>
                </Box>
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box
                                display={'flex'}
                                flexDir={'column'}
                                justifyContent={'start'}
                                alignItems={'start'}
                                width={{ base: '100%', lg: '50%' }}
                                padding={'30ox'}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#1AAC7A'}
                                    mb="30px"
                                >
                                    Poznaj integracje stworzone przez naszych partnerów
                                </Text>
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                    mb={'45px'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Integracje z innymi systemami ERP
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Sprawdź inne integracje z systemami ERP, które są
                                                dostępne dla Twojego sklepu internetowego w IdoSell
                                                Apps.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Lepsze działanie Twojego sklepu
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                IdoSell Apps to nowoczesna platforma, która oferuje
                                                narzędzia i aplikacje wspierające efektywne
                                                zarządzanie sklepem internetowym, automatyzację
                                                procesów oraz integrację z zewnętrznymi
                                                rozwiązaniami.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                                <Link
                                    href="https://www.idosell.com/pl/idosell-apps/"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    margin={'0 auto'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Dowiedz się więcej o IdoSell Apps
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                            <Box width={{ base: '100%', lg: '50%' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611134&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611135&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <ContactSection />
            </div>
        </ThemeProvider>
    );
}
